module.exports = {"version":{"major":1,"minor":2,"patch":30},"status":{"stage":"beta","number":0},"build":{"date":null,"number":0,"total":0},"commit":null,"config":{"appversion":"1.7.1","markdown":[],"json":[],"ignore":[]}}


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/appversion.json
// module id = ../../../../../appversion.json
// module chunks = main